import type { Role } from '@/modules/common/enums/role.ts';
import type { RoleDto } from '@/modules/common/dto/role.dto.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';

export class RoleAdapter {
  private static map(response: RoleDto): Role {
    return response.ROLE_ID;
  }

  static mapList(response: ItemsDto<RoleDto>) {
    return response.items.map(RoleAdapter.map);
  }
}
